// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__EswWK","left":"InfoRow_left__3Y6X9"};